var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNeedapartment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 81 94"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2.688,
  d: "m46.347 4.541 30.323 31.98a7.95 7.95 0 0 1 2.207 5.507v42.358c0 4.448-3.63 8.048-8.115 8.048H10.115C5.63 92.434 2 88.834 2 84.386V42.028c0-2.047.783-4.024 2.207-5.506L34.53 4.542c3.203-3.39 8.613-3.39 11.817 0Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2.688,
  d: "M9.118 29.248V7.363c0-2.118 2.207-3.883 4.912-3.883h5.125c2.705 0 4.911 1.765 4.911 3.883v6.848"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.13 71.338c-.272 1.427-.757 2.854-1.485 4.157a1.07 1.07 0 0 0 .455 1.49c1.061.527 2.85 1.333 5.003 1.86 2.335.59 5.124.9 7.914.28.576-.124.94-.683.85-1.272-.243-1.241-.395-3.568.636-6.546a1.05 1.05 0 0 1 .788-.682c6.156-1.055 10.856-6.546 10.856-13.154 0-3.723-1.486-7.073-3.881-9.524-3.306-3.32-8.733-2.792-11.432 1.086-1.577 2.265-4.154 4.591-8.218 5.212-.97.155-1.94 0-2.88-.28-.516-.155-1.152-.093-1.82.59-1.576 1.644-.485 6.422 1.365 6.856.152.031.303.062.424.062.516 0 1.062.372 1.274.869.03.062.637 1.396.303 3.195"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.731 63.285s-2.595 2.545-8.09.642"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.955 71.375c-6.992-2.947-11.886-9.958-11.886-18.147 0-10.827 8.603-19.605 19.213-19.605S59.495 42.4 59.495 53.228c0 3.133-.973 6.173-2.25 8.81"
})))));
export default SvgNeedapartment;